<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <!-- Delivery Receipient -->
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Delivered To:
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        {{ dropOffDetails.line1 }},

        <template v-if="dropOffDetails.line2">
          {{ dropOffDetails.line2 }},
        </template>

        <span>
          {{ dropOffDetails.city }},
          {{ dropOffDetails.state }}
          {{ dropOffDetails.postalCode }}
        </span>
      </p>

    </div>

    <cf-title-separator :omit-title="true" />

    <!-- Delivery Sender -->
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Delivered From:
      </h3>

      <cf-receipt-from-location-details :store="receipt.store" />
    </div>

    <!-- Delivery Drop off Instructions -->
    <template v-if="receipt.delivery.dropOffInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          Delivery Instructions:
        </h3>

        <p class="cf-subtitle cf-subtitle--2">
          {{ receipt.delivery.dropOffInstructions }}
        </p>
      </div>
    </template>

    <!-- Additional Info -->
    <template v-if="receipt.pickupInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          Additional Info:
        </h3>

        <cf-formatted-content
          class="dark"
          :content="receipt.pickupInstructions"
        />
      </div>
    </template>

    <cf-title-separator :omit-title="true" />
  </div>
</template>


<script>
  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfReceiptFromLocationDetails from '@/view/components/globals/cf-receipt-from-location-details/index.vue';
  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';


  export default {
    name: 'DeliveryReceiptFulfillmeDetails',

    components: {
      CfReceiptFromLocationDetails,
      CfFormattedContent,
      CfTitleSeparator
    },

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      dropOffDetails() {
        return this.receipt.delivery.dropOffAddress;
      },

      storeAddress() {
        return this.receipt.store.address;
      },

      storePhoneNumber() {
        return this.receipt.store.phoneNumber;
      }
    }
  };
</script>
